import { HandleTableData } from '@wajeez-web/components/data-table';
import { DataTableWrapper } from '@wajeez-web/components/helpers';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { CheckBoxType } from '@wajeez-web/components/mui';
import { SalesActions, useAccountSelector } from '@wajeez-web/stores/account';
import { contentEntityDataType } from '@wajeez-web/stores/content';

export const SalesAnalysisDatatable = () => {
  const salesAnalysisDatatable = useAccountSelector(
    ({ sales }) => sales.salesAnalysisDatatable
  );

  const { tablePreferances, setTablePreferences, isTableReferencesLoading } =
    HandleTableData(
      'salesAnalysis',
      SalesActions.getUtilityAnalysisDatatableAsync
    );

  return (
    <div className="h-full">
      <PageLayoutsContainer
        title={`Sales Analysis Table`}
        withoutRightPadding={false}
        breadCrumbsLinks={[{ title: 'Sales Analysis Table' }]}
      >
        <div className="mt-6">
          <DataTableWrapper
            data={salesAnalysisDatatable.data as contentEntityDataType}
            onHeaderManage={(header) => {
              const flags = header
                ?.filter((h) => h.selected)
                .reduce(
                  (previousValue: number, currentValue: CheckBoxType) =>
                    previousValue + Number(currentValue.value),
                  0
                );

              tablePreferances &&
                flags &&
                setTablePreferences({
                  ...tablePreferances,
                  flags: flags + 1,
                });
            }}
            onPaginationChange={(pagination) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  pageNumber: pagination.pageNumber,
                  pageSize: pagination.pageSize,
                });
            }}
            sort={tablePreferances?.sortingOperations?.[0]}
            onSort={(sort) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  sortingOperations: [sort],
                });
            }}
            onFilter={(filters, pagination) => {
              tablePreferances &&
                setTablePreferences({
                  ...tablePreferances,
                  pageNumber: pagination.pageNumber,
                  filteringOperations: filters.map((f) => {
                    return {
                      property: Number(f.key),
                      cretiria: f.value,
                      comparisonType: f.operator,
                    };
                  }),
                });
            }}
            isLoading={salesAnalysisDatatable.status === 'loading'}
            preferences={tablePreferances || undefined}
            setPreferences={setTablePreferences}
          />
        </div>
      </PageLayoutsContainer>
    </div>
  );
};
